import { useQuery } from "urql";
import { ChatListDocument } from "../state/generated/graphql";

export function useChatList() {
  return useQuery({ query: ChatListDocument });
}
